import { PatchDataWrapper } from '@diamond/shared/data-access';
import { BackofficeActivitiesOrderItem } from '@diamond/shared/types';

import { EditableColumnProps } from '../../../types/activity-column-types';

interface Props
  extends EditableColumnProps<
    BackofficeActivitiesOrderItem,
    boolean | undefined
  > {
  activitiesId: string;
  token?: string;
  refetch: () => void;
}

const API_URL = 'backoffice/order';

export function IsNotProcessedColumn({
  info,
  selectedData,
  activitiesId,
  token,
  refetch,
}: Props) {
  const { patchData } = PatchDataWrapper<unknown>(
    API_URL,
    token || '',
    'admin'
  );

  const isChecked = info.getValue();

  const handleClick = () => {
    if (!isChecked) {
      patchData(
        { confirmed_quantity: 0 },
        undefined,
        `${activitiesId}/item/${info.row.original.id}`
      ).then(() => {
        refetch();
      });
    }
  };

  return (
    <div className="px-1">
      <input
        type="checkbox"
        checked={isChecked}
        onChange={handleClick}
        className={'cursor-pointer'}
      />
    </div>
  );
}
